import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import React from 'react';
import { contacts, selectors as profileSelectors } from '../../../../modules/customer/profile';
import LoadingPanel from '../../../components/LoadingPanel';
import ActionButton from '../../../components/ActionButton';

const AddContact = ({ activePanelId, togglePanel, saveContact, toggleButton, buttonEnabled, customerId, isPosting, fetchContacts }) => {
    
    let commentInput;

    const action = e => {
        e.preventDefault();
        if (buttonEnabled) {
            saveContact(commentInput.value, customerId);
            setTimeout(() => fetchContacts(customerId), 3000);
        }
    }


    return <div className="add-contact">
        {isPosting && <LoadingPanel />}
        {!isPosting && <div>
            <textarea className="contact-text"
                placeholder='Nye notater'
                onChange={e => toggleButton(commentInput.value.length > 0)}
                ref={node => { commentInput = node; }}
                />
            <div className="button-panel">
                <ActionButton action={action} title="Lagre henvendelse" active={buttonEnabled} className="big green right-button" />
            </div>
        </div>
        }
    </div>
}

const mapStateToProps = createStructuredSelector({
    customerId: profileSelectors.getCustomerID,
    buttonEnabled: contacts.selectors.isButtonEnabled,
    isPosting: contacts.selectors.isPosting,
    isLoading: contacts.selectors.isLoading
});

const mapDispatchToProps = (dispatch, props) => ({
    toggleButton: enabled => dispatch(contacts.actions.toggleButton(enabled)),
    saveContact: (comment, customerId) => dispatch(contacts.actions.saveContact(comment, customerId)),
    fetchContacts: (customerId) => dispatch(contacts.actions.fetchContacts(customerId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddContact);
